import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "@/components/ui/toaster";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import BabUpgradesPage from "./pages/BabUpgradesPage";
import MPPProjectPage from "./pages/MPPProjectPage";
import WestToEastPage from "./pages/WestToEastPage";
import FujairahBCPage from "./pages/FujairahBCPage";
import BuhasaTieInsPage from "./pages/BuhasaTieInsPage";
import ASABPhase2Page from "./pages/ASABPhase2Page";
import RumailaOilFieldPage from "./pages/RumailaOilFieldPage";
import TawkeOilFieldPage from "./pages/TawkeOilFieldPage";
import AlHalfayaOilFieldPage from "./pages/AlHalfayaOilFieldPage";
import WestQurnaPhase2Page from "./pages/WestQurnaPhase2Page";
import MombasaNairobiPage from "./pages/MombasaNairobiPage";
import PreAwardServicesPage from "./pages/PreAwardServicesPage";
import PostAwardServicesPage from "./pages/PostAwardServicesPage";
import EngineeringServicesPage from "./pages/EngineeringServicesPage";
import ConstructionServicesPage from "./pages/ConstructionServicesPage";
import QualityManagementPage from "./pages/QualityManagementPage";
import ProfessionalEnrichmentPage from "./pages/ProfessionalEnrichmentPage";
import SupplyChainManagementPage from "./pages/SupplyChainManagementPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import MoreProjectsPage from "./pages/MoreProjectsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/pre-award" element={<PreAwardServicesPage />} />
          <Route path="/services/post-award" element={<PostAwardServicesPage />} />
          <Route path="/services/engineering" element={<EngineeringServicesPage />} />
          <Route path="/services/construction" element={<ConstructionServicesPage />} />
          <Route path="/services/quality-management" element={<QualityManagementPage />} />
          <Route path="/services/professional-enrichment" element={<ProfessionalEnrichmentPage />} />
          <Route path="/services/supply-chain" element={<SupplyChainManagementPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/bab-upgrades" element={<BabUpgradesPage />} />
          <Route path="/projects/mpp-project" element={<MPPProjectPage />} />
          <Route path="/projects/west-to-east" element={<WestToEastPage />} />
          <Route path="/projects/fujairah-bc" element={<FujairahBCPage />} />
          <Route path="/projects/buhasa-tie-ins" element={<BuhasaTieInsPage />} />
          <Route path="/projects/asab-phase2" element={<ASABPhase2Page />} />
          <Route path="/projects/rumaila" element={<RumailaOilFieldPage />} />
          <Route path="/projects/tawke" element={<TawkeOilFieldPage />} />
          <Route path="/projects/al-halfaya" element={<AlHalfayaOilFieldPage />} />
          <Route path="/projects/west-qurna" element={<WestQurnaPhase2Page />} />
          <Route path="/projects/mombasa-nairobi" element={<MombasaNairobiPage />} />
          <Route path="/projects/more" element={<MoreProjectsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
